const indicatorsTemplate = require("20220101/templates/widgets/photo-modal/shopable-indicators.hbs");
const linksTemplate = require("20220101/templates/widgets/photo-modal/shopable-links.hbs");

const SHOPABLE_RADIUS = 10;

export default class {
  constructor(container, options) {
    this.container = container;
    this.options = options;
    this.linkTarget = this.options.linkTarget;

    this.shopableIndicators = this.container.getElementsByClassName("shopable-indicator");
    this.shopableLinks = this.container.getElementsByClassName("shopable-link");
    this.photoContainer = this.container.getElementsByClassName("l2h-product-photo")
  }

  bindEvents() {
    let wrapper = this.container.querySelector(".l2h-shopables-wrapper");

    ["mouseenter", "mouseleave"].forEach((type) => {
      wrapper.addEventListener(type, (e) => {
        this.toggleShopableVisibility();
      });

      if (this.canHover) {
        Array.from(this.shopableIndicators).forEach((shopableIndicator) => {
          shopableIndicator.addEventListener(type, (e) => {
            this.handleShopableIndicatorEvent(shopableIndicator, type);
          });
        });

        Array.from(this.shopableLinks).forEach((shopableLink) => {
          shopableLink.addEventListener(type, (e) => {
            this.handleShopableLinkEvent(shopableLink, type);
          });
        });
      }

    });
  }

  showShopables() {
    Array.from(this.shopableIndicators).forEach((indicator) => {
      indicator.classList.remove("hidden");
    });
  }

  hideShopables() {
    Array.from(this.shopableIndicators).forEach((indicator) => {
      indicator.classList.add("hidden");
    });
  }

  toggleShopableVisibility() {
    Array.from(this.shopableIndicators).forEach((indicator) => {
      indicator.classList.toggle("hidden");
    });
  }

  handleShopableIndicatorEvent(el, type) {
    let link = Array.from(this.shopableLinks).find(link => link.dataset.shopableId == el.dataset.shopableId);

    if (link) {
      link.classList.toggle("active");
    }
  }

  handleShopableLinkEvent(el, type) {
    let indicator = Array.from(this.shopableIndicators).find(indicator => indicator.dataset.shopableId == el.dataset.shopableId);

    if (indicator) {
      indicator.classList.toggle("l2h-highlighted");
      indicator.classList.toggle("hidden");
    }
  }

  render(shopables) {
    if (shopables != null) { this.shopables = shopables; }

    const photoWidth = this.photoContainer[0].offsetWidth;
    const photoHeight = this.photoContainer[0].offsetHeight;
    const styledShopables = this.styledShopableIndicators(photoWidth, photoHeight, SHOPABLE_RADIUS);

    const context = {
      shopables: styledShopables,
      single: (this.shopables.length === 1) && this.options.preferences.showShopitButton,
      linkTarget: this.linkTarget,
      preferences: this.options.preferences
    };

    if (this.options.preferences.showProductPhotos) {
      context.shopablesWithPhoto = this.shopablesWithPhoto(styledShopables);
      context.shopablesWithoutPhoto = this.shopablesWithoutPhoto(styledShopables);
    }

    this.container.querySelector('.l2h-shopable-indicators').innerHTML = indicatorsTemplate(context);
    this.container.querySelector('.l2h-shopable-links').innerHTML = linksTemplate(context);

    if (!this.canHover) { this.showShopables() };

    this.bindEvents();
  }

  shopablesWithoutPhoto(shopables) {
    return shopables.filter(shopable => !(shopable.product && shopable.product.photo_url));
  }

  shopablesWithPhoto(shopables) {
    return shopables.filter(shopable => shopable.product && shopable.product.photo_url);
  }

  styledShopableIndicators(photoWidth, photoHeight, shopableRadius) {
    return this.shopables.map((shopable, index) => {
      return Object.assign({}, shopable, {index: index + 1, style: this.styleForShopable(shopable, photoWidth, photoHeight, shopableRadius)});
    });
  }

  styleForShopable(shopable, photoWidth, photoHeight, radius) {
    const w = radius * 2;
    const h = w;

    const top  = (shopable.y * photoHeight) - radius;
    const left = (shopable.x * photoWidth)  - radius;
    return `width:${w}px; height:${h}px; line-height:${h}px; border-radius:${radius}px; top:${top}px; left:${left}px;`;
  }

  get canHover() {
    return window.matchMedia('(hover: hover)').matches;
  }
}
